import { useMutation, useQuery } from "@apollo/react-hooks";
import {
  GET_MY_NOTIFICATIONS,
  MARK_ALL_NOTIFICATIONS_AS_READ,
  MARK_NOTIFICATION_AS_READ,
} from "./queries";

const NOTIFICATIONS_LIMIT = 10;
const POLL_INTERVAL_MS = 30000;

export default function useUserNotifications() {
  const { data, loading, refetch } = useQuery(GET_MY_NOTIFICATIONS, {
    variables: { limit: NOTIFICATIONS_LIMIT },
    fetchPolicy: "cache-and-network",
    pollInterval: POLL_INTERVAL_MS,
  });
  const [markAsRead] = useMutation(MARK_NOTIFICATION_AS_READ);
  const [markAllAsRead, { loading: markingAll }] = useMutation(
    MARK_ALL_NOTIFICATIONS_AS_READ,
  );

  const feed = data?.myNotifications || {};

  const readNotification = async (notification) => {
    if (!notification?.readAt) {
      await markAsRead({ variables: { id: notification.id } });
      await refetch();
    }
  };

  const readAllNotifications = async () => {
    await markAllAsRead();
    await refetch();
  };

  return {
    notifications: feed.items || [],
    unreadCount: feed.unreadCount || 0,
    loading: loading && !data,
    markingAll,
    readNotification,
    readAllNotifications,
  };
}
